<template lang="pug">
b-modal(id="modal-service_name_change" hide-header-close no-close-on-esc no-close-on-backdrop title="サービス名の変更について")
  div ・2024年2月20日よりサービス名を賢瓦からSiteLead（サイトリード）に変更となります。
  div ・2024年2月20日以降にご請求するクレジットカード明細には、SiteLead(旧:賢瓦)と記載されます。
  div ・今後サービスの案内を、【support@sitelead.net】および【no-reply@mail.sitelead.net】のメールアドレスからお送りします。

  template(v-slot:modal-footer)


    
    template.text-center()
    b-button(variant="success", @click="submit($event)" ) 確認
      
</template>

<script>
  import Vue from 'vue'

  export default {
    props: {
      policy_accepted_at: String
    },
    data() {
      return {
        company_name: '',
        tel: '',
        host: '',
        label: '',
      }
    },
    methods: {
  
      async submit(e){

        e.preventDefault();
        // ディレクトリは削除して登録
        await this.$store.dispatch("user/saveServiceChange")
        window.location.href = '/users';
        this.$bvModal.hide('modal-service_name_change')
      },
    },
    components: {
    },
    async mounted(){
      await Vue.nextTick()
      this.$bvModal.show('modal-service_name_change')
    },
  }
</script>

<style lang="scss" scoped>
.modal-footer {
  justify-content: center;
}
.btn-auth-login {
  background-color: #ffffff;
  border-radius: 20px;
}
.icon-google {
  background-color: #ffffff;
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  width: 30px;
  height: 30px;
}
</style>

